import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beUpdateSalonBillingData';
const AT = actionType(ATAG);

const beUpdateSalonBillingData = withOptions(({ salonId, name, email, action }) =>
  endpoint(H.post, 'stripe/:salonId/post_customer/', {
    AT,
    name: ATAG,
    params: { salonId },
    data: { name, email, action },
  }),
);

beUpdateSalonBillingData.AT = AT;
beUpdateSalonBillingData.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beUpdateSalonBillingData;
